module.exports = __webpack_public_path__ + "img/dryva-screen-11.e3a9615e.png";